/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".mobView[_ngcontent-%COMP%]{display:inline-block}.font-weight-normal-calibre[_ngcontent-%COMP%]{font-family:Calibre!important}"];
export { styles as styles };

